export default __webpack_public_path__ + "static/media/CI.91bd6554.svg";